module.exports = __webpack_public_path__ + "img/0123.493bb2ba.png";